import { createAsyncThunk } from "@reduxjs/toolkit";
import { GET_ORDER_DETAILS, LIST_ORDER } from "../../../constants/url_helpers";
import { axiosDROPPAdmin } from "../../../services/api";

export const orderList = createAsyncThunk(
  "order/orderList",
  async (payload, thunk) => {
    try {
      const res = await axiosDROPPAdmin.post(LIST_ORDER, payload);
      let json = await res.data;
      return json;
    } catch (e) {
      const errorMessage = e?.message || "Network Error";
      console.error("Error:", errorMessage);
      return thunk.rejectWithValue(errorMessage);
    }
  }
);

export const getOrderDetails = createAsyncThunk(
  "order/getOrderDetails",
  async (payload, thunk) => {
    try {
      const res = await axiosDROPPAdmin.post(GET_ORDER_DETAILS, payload);
      let json = await res.data;
      return json;
    } catch (e) {
      const errorMessage = e?.message || "Network Error";
      console.error("Error:", errorMessage);
      return thunk.rejectWithValue(errorMessage);
    }
  }
);
